module.exports = __webpack_public_path__ + "static/media/trash-restore-alt.3ba8349b.svg";